import React from 'react';
import CatMenu from '../Header/CatMenu';
import SearchField from '../Header/SearchField';
import CornerCart from '../Header/CornerCart';
import './style/index.less';

class StickyHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSticky: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const scrollHeight = window.pageYOffset;
    const standardHeight = 475;

    if (scrollHeight > standardHeight) {
      this.setState({ isSticky: true });
    } else {
      this.setState({ isSticky: false });
    }
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const { isSticky } = this.state;
    return (
      <header
        className={isSticky ? 'fixed-header fixed-header-active' : ' fixed-header'}
        fullscreen
      >
        <div className="media-homepage-width main-constants-padding  fixed-wrap">
          <CatMenu />
          <div className="middle-wrapper">
            <SearchField isShow={false} />
            <CornerCart />
          </div>
        </div>
      </header>
    );
  }
}

export default StickyHeader;
